<template>
  <div class="main-container">
    <div class="inner-container">
        <div class="filter-input-container">
            <div class="inner-filter-container">
                <select id="filterField" v-model="selectedField">
                    <option disabled selected value="">Filter Options</option>
                    <option v-if="filterByService" value="service">Service</option>
                    <option v-if="filterByReference" value="ref1">All References</option>
                    <option v-if="filterByCompanyName" value="serviceAddress.address.companyName">Company or Name</option>
                    <option v-if="filterByCustomerName" value="serviceAddress.address.attention">Contact Name</option>
                    <option v-if="filterByAddress" value="address1">Delivery Address</option>
                    <option v-if="filterByBillingAddress" value="billingAddress1">Address</option>
                    <option v-if="filterByPickupAddress" value="pickupAddress1">Pickup Address</option>
                    <option v-if="filterByDeliveryInstructions" value="deliveryInstructions">Delivery Instructions</option>
                    <option v-if="filterByDescription" value="description">Description</option>
                    <option v-if="filterByCity" value="serviceAddress.address.city">City</option>
                    <option v-if="filterByState" value="serviceAddress.address.state">State</option>
                    <option v-if="filterByZipCode" value="serviceAddress.address.zipCode">ZipCode</option>
                    <option v-if="filterByGeoCode" value="zipCode">GeoCode</option>
                    <option v-if="filterByRouteCode" value="routeCode">RouteCode</option>
                    <option v-if="filterByAccountNo" value="accountNo">Account No.</option>
                    <option v-if="filterByInvoiceID" value="invoiceID">Invoice ID</option>
                    <option v-if="filterByUserName" value="username">Username</option>
                    <option v-if="filterByServiceNetwork" value="serviceNetwork">Service Network</option>
                    <option v-if="filterByContact1" value="contact1">Contact 1</option>
                    <option v-if="filterByShipmentID" value="shipmentID">Tracking Number</option>
                    <option v-if="filterByDateRange" value="dateRange">Date Range</option>
                    <option v-if="filterByTripSheetID" value="tripSheetID">Trip Sheet ID</option>
                    <option v-if="filterByExternalTrackingNumber" value="externalTrackingNumber">External ID</option>
                    <option v-if="filterByIsContractedDelivery" value="isContractedDelivery">Contracted Delivery</option>
                    <option v-if="filterByEmail" value="email">Email</option>
                    <option v-if="filterByPhone" value="phone">Phone</option>
                    <option v-if="filterBySearchAll" value="searchAll">Search All</option>
                </select>
            </div>

            <form style="text-align: left;" @submit.prevent="filterData()">
            
            <div class="inner-filter-container" v-if="selectedField == 'service'">
                <select style="margin-left: 5px;" id="filterField" v-model="filterValue">
                    <option disabled selected value="">Service Options</option>
                    <option value="standard">Standard Service</option>
                    <option value="priority">Priority Service</option>
                    <option value="economy">Economy Service</option>
                </select>
            </div>

            <div class="inner-filter-container" v-if="selectedField == 'externalTrackingNumber'">
                <input placeholder="External ID" type="text" id="filterValue" :ref="selectedField" v-model="filterValue">
            </div>

            <div class="inner-filter-container" v-if="selectedField == 'email'">
                <input placeholder="Email" type="text" id="filterValue" :ref="selectedField" v-model="filterValue">
            </div>

            <div class="inner-filter-container" v-if="selectedField == 'phone'">
                <input placeholder="Phone" type="text" id="filterValue" :ref="selectedField" v-model="filterValue">
            </div>

            <div class="inner-filter-container" v-if="selectedField == 'tripSheetID'">
                <input placeholder="Trip Sheet ID" type="text" id="filterValue" :ref="selectedField" v-model="filterValue">
            </div>

            <div class="inner-filter-container" v-if="selectedField == 'ref1'">
                <input placeholder="Reference" type="text" id="filterValue" :ref="selectedField" v-model="filterValue">
            </div>

            <div class="inner-filter-container" v-if="selectedField == 'serviceAddress.address.companyName'">
                <input placeholder="Company Name" type="text" id="filterValue" :ref="selectedField" v-model="filterValue">
            </div>

            <div class="inner-filter-container" v-if="selectedField == 'serviceAddress.address.attention'">
                <input placeholder="Customer Name" type="text" id="filterValue" :ref="selectedField" v-model="filterValue">
            </div>

            <div class="inner-filter-container" v-if="selectedField == 'address1'">
                <input placeholder="Address" type="text" id="filterValue" :ref="selectedField" v-model="filterValue">
            </div>

            <div class="inner-filter-container" v-if="selectedField == 'billingAddress1'">
                <input placeholder="Address" type="text" id="filterValue" :ref="selectedField" v-model="filterValue">
            </div>

            <div class="inner-filter-container" v-if="selectedField == 'pickupAddress1'">
                <input placeholder="Pickup Address" type="text" id="filterValue" :ref="selectedField" v-model="filterValue">
            </div>

            <div class="inner-filter-container" v-if="selectedField == 'searchAll'">
                <input placeholder="Search  All" type="text" id="filterValue" :ref="selectedField" v-model="filterValue">
            </div>

            <div class="inner-filter-container" v-if="selectedField == 'deliveryInstructions'">
                <input placeholder="Delivery Instructions" type="text" id="filterValue" :ref="selectedField" v-model="filterValue">
            </div>

            <div class="inner-filter-container" v-if="selectedField == 'description'">
                <input placeholder="Description" type="text" id="filterValue" :ref="selectedField" v-model="filterValue">
            </div>

            <div class="inner-filter-container" v-if="selectedField == 'serviceAddress.address.city'">
                <input placeholder="City" type="text" id="filterValue" :ref="selectedField" v-model="filterValue">
            </div>

            <div class="inner-filter-container" v-if="selectedField == 'serviceAddress.address.state'">
                <input placeholder="State (ex. NJ)" type="text" id="filterValue" :ref="selectedField" v-model="filterValue">
            </div>

            <div class="inner-filter-container" v-if="selectedField == 'serviceAddress.address.zipCode'">
                <input placeholder="ZipCode (ex. 07103)" type="text" id="filterValue" :ref="selectedField" v-model="filterValue">
            </div>

            <div class="inner-filter-container" v-if="selectedField == 'routeCode'">
                <input placeholder="Route Code" type="text" id="filterValue" :ref="selectedField" v-model="filterValue" @input="filterValue = $event.target.value.toUpperCase()">
            </div>

            <div class="inner-filter-container" v-if="selectedField == 'accountNo'">
                <input placeholder="Account No." type="text" id="filterValue" :ref="selectedField" v-model="filterValue" @input="filterValue = $event.target.value.toUpperCase()">
            </div>

            <div class="inner-filter-container" v-if="selectedField == 'invoiceID'">
                <input placeholder="Invoice ID" type="text" id="filterValue" :ref="selectedField" v-model="filterValue">
            </div>

            <div class="inner-filter-container" v-if="selectedField == 'username'">
                <input placeholder="Username" type="text" id="filterValue" :ref="selectedField" v-model="filterValue">
            </div>

            <div class="inner-filter-container" v-if="selectedField == 'serviceNetwork'">
                <input placeholder="Service Network" type="text" id="filterValue" :ref="selectedField" v-model="filterValue">
            </div>

            <div class="inner-filter-container" v-if="selectedField == 'contact1'">
                <input placeholder="Contact Name" type="text" id="filterValue" :ref="selectedField" v-model="filterValue">
            </div>

            <div class="inner-filter-container" v-if="selectedField == 'shipmentID'">
                <input placeholder="ShipmentID" type="text" id="filterValue" :ref="selectedField" v-model="filterValue">
            </div>

            <div class="inner-filter-container checkbox-container" v-if="selectedField && showFilterByDefaultLocation">
                <label for="DefaultLocation">Default Location</label>
                <input placeholder="DefaultLocation" name="DefaultLocation" type="checkbox" id="filterValue" v-model="toggleFilterByDefaultLocation">
            </div>

            <div v-if="shipmentFilter && !hideDateRange" class="inner-filter-container checkbox-container">
                <label for="">Start Date</label>
                <input placeholder="Start Date" type="date" id="filterValue" v-model="startDate" :min="minDate">
            </div>

            <div v-if="shipmentFilter && !hideDateRange" class="inner-filter-container checkbox-container">
                <label for="">End Date</label>
                <input placeholder="End Date" type="date" id="filterValue" v-model="endDate" :min="minDate">
            </div>

            </form>
            <button @click="filterData()"><i class="fa fa-filter"></i> Enter</button>
        </div>
    </div>
  </div>
<alert-user v-if="toggleAlertBox" @closeAlertBox="closeAlertBox($event)" :message="alertMessage"/>
</template>

<script>
import AlertUser from '../../components/Popups/AlertUser.vue';

export default {
    data(){
        return{
            selectedField: '',
            filterValue: '',
            startDate: '',
            endDate: '',
            minDate: this.calculateMinDate(),
            MAX_RANGE_DAYS: 90,
            toggleAlertBox: false,
            alertMessage: '',
            toggleFilterByDefaultLocation: false
        }
    },
    components:{
        AlertUser
    },
    mounted() {
        const today = new Date();
        const thirtyDaysAgo = new Date();
        thirtyDaysAgo.setDate(today.getDate() - 30);        
        this.startDate = thirtyDaysAgo.toISOString().split("T")[0];
        this.endDate = today.toISOString().split("T")[0];
        console.log(today)
        console.log(thirtyDaysAgo)
    },
    watch:{
        'selectedField': function(){
            console.log("SELECTED FIELD")
            this.filterValue = '';
            this.$nextTick(() => this.$refs[this.selectedField]?.focus())
            console.log(this.selectedField)
        }
    },
    methods:{
        filterData(){
            if(this.shipmentFilter && !this.useAccountTableFilter){
                this.filterValues();
            }

            if(this.useAccountTableFilter){
                this.filterAccountTable();
            }

            if(this.addressBookFilter && !this.useLocationTableFilter){
                this.filterValuesAddressBook();
            }

            if(this.useLocationTableFilter){
                this.filterValuesLocation();
            }

            if(this.useQueuedActivityFilter){
                this.filterValuesQueuedActivities();
            }

            if(this.sameDayFilter){
                this.filterValuesSameDay();
            }
        },
        filterValues(){
            const start = new Date(this.startDate);
            const end = new Date(`${this.endDate}T18:59:59.999`); //Default to end of the day

            const diffInMs = end - start; // milliseconds
            const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

            console.log(diffInDays);
            console.log(start.toISOString())
            console.log(end.toISOString())
            if(diffInDays > 90){
                console.log("TOO LARGE")
                const today = new Date();
                const thirtyDaysAgo = new Date();
                thirtyDaysAgo.setDate(today.getDate() - 30);        
                this.startDate = thirtyDaysAgo.toISOString().split("T")[0];
                this.endDate = today.toISOString().split("T")[0];
                this.toggleAlertBox = true;
                this.alertMessage = "Date range must be less than 90 days. Date reset to 30 days.";
                return;
            }

            if(this.selectedField == ''){
                this.toggleAlertBox = true;
                this.alertMessage = "Select a filter field.";
                return;
            }

            let input = {};
            if(this.selectedField == 'address1'){
                //Multi Match address1 and address 2
                input = {filter: {updatedAt: {gte: start.toISOString(), lte: end.toISOString()}}, match: [], multiMatch: {query: this.filterValue, fields: ["serviceAddress.address.address1", "serviceAddress.address.address2"]}}
            }else if(this.selectedField == 'pickupAddress1'){
                //Multi Match address1 and address2
                input = {filter: {updatedAt: {gte: start.toISOString(), lte: end.toISOString()}}, match: [], multiMatch: {query: this.filterValue, fields: ["deliveryPickup.address.address1", "deliveryPickup.address.address2"]}}
            }else if(this.selectedField == 'ref1'){
                //Multi Match ref1,ref2.ref3,ref4,ref5
                input = {filter: {updatedAt: {gte: start.toISOString(), lte: end.toISOString()}}, match: [], multiMatch: {query: this.filterValue, fields: ["ref1", "ref2", "ref3", "ref4", "ref5", "additionalRefs"]}}
            }else if(this.selectedField == 'searchAll'){
                input = {filter: {updatedAt: {gte: start.toISOString(), lte: end.toISOString()}}, match: [], multiMatch: {query: this.filterValue, fields: [
                    "deliveryPickup.address.address1", 
                    "deliveryPickup.address.address2", 
                    "deliveryPickup.address.companyName",
                    "deliveryPickup.address.city",
                    "deliveryPickup.address.state",
                    "deliveryPickup.address.zipCode",
                    "ref1", 
                    "ref2", 
                    "ref3", 
                    "ref4", 
                    "ref5",
                    "additionalRefs",
                    "serviceAddress.address.address1",
                    "serviceAddress.address.address2",
                    "serviceAddress.address.companyName",
                    "serviceAddress.address.attention",
                    "serviceAddress.address.city",
                    "serviceAddress.address.state",
                    "serviceAddress.address.zipCode",
                    "service",
                    "shipmentID",
                    "deliveryInstructions",
                    "description",
                    "externalTrackingNumber"
                    ]}}
            }else if(this.selectedField == 'dateRange'){
                input = {filter: {updatedAt: {gte: start.toISOString(), lte: end.toISOString()}}, match: []}
            }else{
                input = {filter: {updatedAt: {gte: start.toISOString(), lte: end.toISOString()}}, match: [{key: this.selectedField, value: this.filterValue}]}
            }
            console.log(input)
            this.$emit('filterValuesOpenSearch', {input: input})
            console.log("Emit!")
        },
        filterValuesSameDay(){
            const start = new Date(this.startDate);
            const end = new Date(`${this.endDate}T18:59:59.999`); //Default to end of the day

            const diffInMs = end - start; // milliseconds
            const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

            console.log(diffInDays);
            console.log(start.toISOString())
            console.log(end.toISOString())
            if(diffInDays > 90){
                console.log("TOO LARGE")
                const today = new Date();
                const thirtyDaysAgo = new Date();
                thirtyDaysAgo.setDate(today.getDate() - 30);        
                this.startDate = thirtyDaysAgo.toISOString().split("T")[0];
                this.endDate = today.toISOString().split("T")[0];
                this.toggleAlertBox = true;
                this.alertMessage = "Date range must be less than 90 days. Date reset to 30 days.";
                return;
            }

            let input = {};

            
            if(this.selectedField == ''){
                input = {filter: {updatedAt: {gte: start.toISOString(), lte: end.toISOString()}}, match: []}
            }else if(this.selectedField == 'address1'){
                //Multi Match address1 and address 2
                input = {filter: {updatedAt: {gte: start.toISOString(), lte: end.toISOString()}}, match: [], multiMatch: {query: this.filterValue, fields: ["serviceAddress.address.address1", "serviceAddress.address.address2"]}}
            }else if(this.selectedField == 'pickupAddress1'){
                //Multi Match address1 and address2
                input = {filter: {updatedAt: {gte: start.toISOString(), lte: end.toISOString()}}, match: [], multiMatch: {query: this.filterValue, fields: ["deliveryPickup.address.address1", "deliveryPickup.address.address2"]}}
            }else if(this.selectedField == 'ref1'){
                //Multi Match ref1,ref2.ref3,ref4,ref5
                input = {filter: {updatedAt: {gte: start.toISOString(), lte: end.toISOString()}}, match: [], multiMatch: {query: this.filterValue, fields: ["ref1", "ref2", "ref3", "ref4", "ref5", "additionalRefs"]}}
            }else if(this.selectedField == 'searchAll'){
                input = {filter: {updatedAt: {gte: start.toISOString(), lte: end.toISOString()}}, match: [], multiMatch: {query: this.filterValue, fields: [
                    "deliveryPickup.address.address1", 
                    "deliveryPickup.address.address2", 
                    "deliveryPickup.address.companyName",
                    "deliveryPickup.address.city",
                    "deliveryPickup.address.state",
                    "deliveryPickup.address.zipCode",
                    "ref1", 
                    "ref2", 
                    "ref3", 
                    "ref4", 
                    "ref5",
                    "additionalRefs",
                    "serviceAddress.address.address1",
                    "serviceAddress.address.address2",
                    "serviceAddress.address.companyName",
                    "serviceAddress.address.attention",
                    "serviceAddress.address.city",
                    "serviceAddress.address.state",
                    "serviceAddress.address.zipCode",
                    "service",
                    "shipmentID",
                    "deliveryInstructions",
                    "description",
                    "externalTrackingNumber"
                    ]}}
            }else if(this.selectedField == 'dateRange'){
                input = {filter: {updatedAt: {gte: start.toISOString(), lte: end.toISOString()}}, match: []}
            }else if(this.selectedField == 'routeCode'){
                input = {filter: {updatedAt: {gte: start.toISOString(), lte: end.toISOString()}}, match: [{key: "deliveryPickup.address.routeCode", value: this.filterValue}]}
            }else{
                input = {filter: {updatedAt: {gte: start.toISOString(), lte: end.toISOString()}}, match: [{key: this.selectedField, value: this.filterValue}]}
            }
            console.log(input)
            this.$emit('filterValuesOpenSearch', {input: input})
            console.log("Emit!")
        },
        filterAccountTable(){
            if(this.selectedField == ''){
                this.toggleAlertBox = true;
                this.alertMessage = "Select a filter field.";
                return;
            }

            let input = {};
            if(this.selectedField == 'accountNo'){
                //Multi Match address1 and address 2
                input = {querySource: ["billingAddress.address1", "billingAddress.companyName", "billingAddress.address2", "billingAddress.city", "billingAddress.state", "billingAddress.zipCode", "billingAddress.attention", "accountNo", "contact1"], index: "account-index", match: [{key: "accountNo", value: this.filterValue}]}
            }else if(this.selectedField == 'contact1'){
                //Multi Match address1 and address 2
                input = {querySource: ["billingAddress.address1", "billingAddress.companyName", "billingAddress.address2", "billingAddress.city", "billingAddress.state", "billingAddress.zipCode", "billingAddress.attention", "accountNo", "contact1"], index: "account-index", match: [{key: "contact1", value: this.filterValue}]}
            }else if(this.selectedField == 'serviceAddress.address.companyName'){
                input = {querySource: ["billingAddress.address1", "billingAddress.companyName", "billingAddress.address2", "billingAddress.city", "billingAddress.state", "billingAddress.zipCode", "billingAddress.attention", "accountNo", "contact1"], index: "account-index", match: [], multiMatch: {query: this.filterValue, fields: [
                    "billingAddress.companyName"
                    ]}}
            }else if(this.selectedField == 'billingAddress1'){
                input = {querySource: ["billingAddress.address1", "billingAddress.companyName", "billingAddress.address2", "billingAddress.city", "billingAddress.state", "billingAddress.zipCode", "billingAddress.attention", "accountNo", "contact1"], index: "account-index", match: [], multiMatch: {query: this.filterValue, fields: [
                    "billingAddress.address1",
                    "billingAddress.address2"
                    ]}}
            }else if(this.selectedField == 'email'){
                input = {querySource: ["billingAddress.address1", "billingAddress.companyName", "billingAddress.address2", "billingAddress.city", "billingAddress.state", "billingAddress.zipCode", "billingAddress.attention", "billingAddress.email", "accountNo", "contact1"], index: "account-index", match: [], multiMatch: {query: this.filterValue, fields: [
                    "billingAddress.email"
                    ]}}
            }else if(this.selectedField == 'phone'){
                input = {querySource: ["billingAddress.address1", "billingAddress.companyName", "billingAddress.address2", "billingAddress.city", "billingAddress.state", "billingAddress.zipCode", "billingAddress.attention", "billingAddress.email", "billingAddress.phone", "accountNo", "contact1"], index: "account-index", match: [], multiMatch: {query: this.filterValue, fields: [
                    "billingAddress.phone"
                    ]}}
            }else if(this.selectedField == 'searchAll'){
                input = {querySource: ["billingAddress.address1", "billingAddress.companyName", "billingAddress.address2", "billingAddress.city", "billingAddress.state", "billingAddress.zipCode", "billingAddress.attention", "billingAddress.email", "billingAddress.phone", "accountNo", "contact1"], index: "account-index", match: [], multiMatch: {query: this.filterValue, fields: [
                    "billingAddress.address1", "billingAddress.companyName", "billingAddress.address2", "billingAddress.city", "billingAddress.state", "billingAddress.zipCode", "billingAddress.attention", "billingAddress.email", "billingAddress.phone", "accountNo", "contact1"
                    ]}}
            }else{
                this.toggleAlertBox = true;
                this.alertMessage = "Select a valid filter field.";
            }
            console.log(input)
            this.$emit('filterValuesOpenSearch', {input: input})
            console.log("Emit!")
        },
        filterValuesAddressBook(){
            if(this.selectedField == ''){
                this.toggleAlertBox = true;
                this.alertMessage = "Select a filter field.";
                return;
            }

            let input = {};
            if(this.selectedField == 'address1'){
                //Multi Match address1 and address 2
                input = {querySource: ["address1", "companyName", "address2", "city", "state", "zipCode", "attention", "id"], index: "addressbook-index", match: [], multiMatch: {query: this.filterValue, fields: ["address1", "address2"]}}
            }else if(this.selectedField == 'serviceAddress.address.companyName'){
                input = {querySource: ["address1", "companyName", "address2", "city", "state", "zipCode", "attention", "id"], index: "addressbook-index", match: [], multiMatch: {query: this.filterValue, fields: [
                    "companyName"
                    ]}}
            }else if(this.selectedField == 'serviceAddress.address.attention'){
                input = {querySource: ["address1", "companyName", "address2", "city", "state", "zipCode", "attention", "id"], index: "addressbook-index", match: [], multiMatch: {query: this.filterValue, fields: [
                    "attention"
                    ]}}
            }else if(this.selectedField == 'serviceAddress.address.city'){
                input = {querySource: ["address1", "companyName", "address2", "city", "state", "zipCode", "attention", "id"], index: "addressbook-index", match: [], multiMatch: {query: this.filterValue, fields: [
                    "city"
                    ]}}
            }else if(this.selectedField == 'serviceAddress.address.state'){
                input = {querySource: ["address1", "companyName", "address2", "city", "state", "zipCode", "attention", "id"], index: "addressbook-index", match: [], multiMatch: {query: this.filterValue, fields: [
                    "state"
                    ]}}
            }else if(this.selectedField == 'serviceAddress.address.zipCode'){
                input = {querySource: ["address1", "companyName", "address2", "city", "state", "zipCode", "attention", "id"], index: "addressbook-index", match: [], multiMatch: {query: this.filterValue, fields: [
                    "zipCode"
                    ]}}
            }
            else if(this.selectedField == 'searchAll'){
                input = {querySource: ["address1", "companyName", "address2", "city", "state", "zipCode", "attention", "id"], index: "addressbook-index", match: [], multiMatch: {query: this.filterValue, fields: [
                    "address1", 
                    "address2", 
                    "companyName",
                    "city",
                    "state",
                    "zipCode",
                    "attention"
                    ]}}
            }else{
                this.toggleAlertBox = true;
                this.alertMessage = "Select a valid filter field.";
            }
            console.log(input)
            this.$emit('filterValuesOpenSearch', {input: input})
            console.log("Emit!")
        },
        filterValuesLocation(){
            console.log("GET LOCATION DATA")
            console.log("Selected Field: ", this.selectedField)
            if(this.selectedField == ''){
                this.toggleAlertBox = true;
                this.alertMessage = "Select a filter field.";
                return;
            }

            let input = {};
            if(this.selectedField == 'address1'){
                //Multi Match address1 and address 2
                input = {querySource: ["serviceAddress.address.address1", "serviceAddress.address.companyName", "serviceAddress.address.address2", "serviceAddress.address.city", "serviceAddress.address.state", "serviceAddress.address.zipCode", "serviceAddress.address.attention", "id"], index: "location-index", match: [], multiMatch: {query: this.filterValue, fields: ["serviceAddress.address.address1", "serviceAddress.address.address2"]}}
            }else if(this.selectedField == 'serviceAddress.address.companyName'){
                input = {querySource: ["serviceAddress.address.address1", "serviceAddress.address.companyName", "serviceAddress.address.address2", "serviceAddress.address.city", "serviceAddress.address.state", "serviceAddress.address.zipCode", "serviceAddress.address.attention", "id"], index: "location-index", match: [], multiMatch: {query: this.filterValue, fields: [
                    "serviceAddress.address.companyName"
                    ]}}
            }else if(this.selectedField == 'serviceAddress.address.attention'){
                input = {querySource: ["serviceAddress.address.address1", "serviceAddress.address.companyName", "serviceAddress.address.address2", "serviceAddress.address.city", "serviceAddress.address.state", "serviceAddress.address.zipCode", "serviceAddress.address.attention", "id"], index: "location-index", match: [], multiMatch: {query: this.filterValue, fields: [
                    "serviceAddress.address.attention"
                    ]}}
            }else if(this.selectedField == 'serviceAddress.address.city'){
                input = {querySource: ["serviceAddress.address.address1", "serviceAddress.address.companyName", "serviceAddress.address.address2", "serviceAddress.address.city", "serviceAddress.address.state", "serviceAddress.address.zipCode", "serviceAddress.address.attention", "id"], index: "location-index", match: [], multiMatch: {query: this.filterValue, fields: [
                    "serviceAddress.address.city"
                    ]}}
            }else if(this.selectedField == 'serviceAddress.address.state'){
                input = {querySource: ["serviceAddress.address.address1", "serviceAddress.address.companyName", "serviceAddress.address.address2", "serviceAddress.address.city", "serviceAddress.address.state", "serviceAddress.address.zipCode", "serviceAddress.address.attention", "id"], index: "location-index", match: [], multiMatch: {query: this.filterValue, fields: [
                    "serviceAddress.address.state"
                    ]}}
            }else if(this.selectedField == 'serviceAddress.address.zipCode'){
                input = {querySource: ["serviceAddress.address.address1", "serviceAddress.address.companyName", "serviceAddress.address.address2", "serviceAddress.address.city", "serviceAddress.address.state", "serviceAddress.address.zipCode", "serviceAddress.address.attention", "id"], index: "location-index", match: [], multiMatch: {query: this.filterValue, fields: [
                    "serviceAddress.address.zipCode"
                    ]}}
            }else if(this.selectedField == 'accountNo'){
                input = {querySource: ["serviceAddress.address.address1", "serviceAddress.address.companyName", "serviceAddress.address.address2", "serviceAddress.address.city", "serviceAddress.address.state", "serviceAddress.address.zipCode", "serviceAddress.address.attention", "id"], index: "location-index", match: [{key: "accountNo", value: this.filterValue}]}
            }
            else if(this.selectedField == 'isContractedDelivery'){
                input = {querySource: ["serviceAddress.address.address1", "serviceAddress.address.companyName", "serviceAddress.address.address2", "serviceAddress.address.city", "serviceAddress.address.state", "serviceAddress.address.zipCode", "serviceAddress.address.attention", "id"], index: "location-index", match: [{key: "isContractedDelivery", value: true}]}
            }
            else if(this.selectedField == 'searchAll'){
                input = {querySource: ["serviceAddress.address.address1", "serviceAddress.address.companyName", "serviceAddress.address.address2", "serviceAddress.address.city", "serviceAddress.address.state", "serviceAddress.address.zipCode", "serviceAddress.address.attention", "id"], index: "location-index", match: [], multiMatch: {query: this.filterValue, fields: [
                    "serviceAddress.address.address1", 
                    "serviceAddress.address.address2", 
                    "serviceAddress.address.companyName",
                    "serviceAddress.address.city",
                    "serviceAddress.address.state",
                    "serviceAddress.address.zipCode",
                    "serviceAddress.address.attention"
                    ]}}
            }else{
                this.toggleAlertBox = true;
                this.alertMessage = "Select a valid filter field.";
            }

            if(this.toggleFilterByDefaultLocation){
                input.filter = {
                    isDefaultLocation: true
                }
            }

            console.log(input)
            this.$emit('filterValuesOpenSearch', {input: input})
            console.log("Emit!")
        },
        filterValuesQueuedActivities(){
            if(this.selectedField == ''){
                this.toggleAlertBox = true;
                this.alertMessage = "Select a filter field.";
                return;
            }

            let input = {};
            if(this.selectedField == 'routeCode'){
                //Multi Match address1 and address 2
                input = {querySource: ["routeCode", "shipmentID", "queuedActivity", "serviceAddressCompanyName", "pickupAddressCompanyName", "accountNo"], index: "queuedshipment-index", match: [{key: "routeCode", value: this.filterValue}]}
            }else if(this.selectedField == 'shipmentID'){
                input = {querySource: ["routeCode", "shipmentID", "queuedActivity", "serviceAddressCompanyName", "pickupAddressCompanyName", "accountNo"], index: "queuedshipment-index", match: [{key: "shipmentID", value: this.filterValue}]}
            }else if(this.selectedField == 'serviceAddress.address.companyName'){
                input = {querySource: ["routeCode", "shipmentID", "queuedActivity", "serviceAddressCompanyName", "pickupAddressCompanyName", "accountNo"], index: "queuedshipment-index", match: [], multiMatch: {query: this.filterValue, fields: [
                    "serviceAddressCompanyName",
                    "pickupAddressCompanyName"
                    ]}}
            }else if(this.selectedField == 'accountNo'){
                input = {querySource: ["routeCode", "shipmentID", "queuedActivity", "serviceAddressCompanyName", "pickupAddressCompanyName", "accountNo"], index: "queuedshipment-index", match: [], multiMatch: {query: this.filterValue, fields: [
                    "accountNo"
                    ]}}
            }
            else if(this.selectedField == 'searchAll'){
                input = {querySource: ["routeCode", "shipmentID", "queuedActivity", "serviceAddressCompanyName", "pickupAddressCompanyName", "accountNo"], index: "queuedshipment-index", match: [], multiMatch: {query: this.filterValue, fields: [
                    "routeCode", "shipmentID", "queuedActivity", "serviceAddressCompanyName", "pickupAddressCompanyName", "accountNo"
                    ]}}
            }else{
                this.toggleAlertBox = true;
                this.alertMessage = "Select a valid filter field.";
            }
            console.log(input)
            this.$emit('filterValuesOpenSearch', {input: input})
            console.log("Emit!")
        },
        closeAlertBox(toggleAlertBox){
            this.toggleAlertBox = toggleAlertBox;
        },
        calculateMinDate() {
            const today = new Date();
            const oneYearAgo = new Date(today.getFullYear() - 1, today.getMonth(), today.getDate());
            return oneYearAgo.toISOString().split('T')[0]; // Formats as YYYY-MM-DD
        }
    },
    computed:{
        shipmentFilter(){
            return this.$route.name == 'ShipmentDashboard' || this.$route.name == 'AdminShipmentDashboard' || this.$route.name == 'CustomerAdminShipmentDashboard'
        },
        addressBookFilter(){
            return this.$route.name == 'AddressBookDashboard' || this.$route.name == 'Ship'
        },
        sameDayFilter(){
            return this.$route.name == 'SameDayDashboard' || this.$route.name == "PickupDashboard"
        }
    },
    props:['showFilterByDefaultLocation', 'useQueuedActivityFilter', 'useLocationTableFilter', 'filterByPhone', 'filterByEmail', 'filterByBillingAddress', 'hideDateRange', 'useAccountTableFilter', 'filterByCustomerName', 'filterBySearchAll', 'filterByDescription', 'filterByDeliveryInstructions', 'filterByPickupAddress', 'setIsoDateTime', 'filterByTripSheetID', 'filterByIsContractedDelivery', 'filterByExternalTrackingNumber', 'filterByDateRange', 'filterByShipmentID', 'filterByAccountNo', 'filterByService', 'filterByReference', 'filterByCompanyName', 'filterByAddress', 'filterByCity', 'filterByState', 'filterByZipCode', 'filterByGeoCode', 'filterByRouteCode', 'filterByUserName', 'filterByContact1', 'filterByServiceNetwork', 'filterByInvoiceID']
}
</script>

<style scoped>
.main-container {
	width: 100%;
	display: flex;
	justify-content: flex-start;
	margin-bottom: 10px;
	margin-top: 5px
}

.inner-container {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-start;
	width: calc(100% - 20px);
	padding: 5px;
	background-color: #fff;
	box-shadow: rgba(0, 0, 0, .15) 0 5px 10px;
	border-radius: 25px
}

.filter-input-container {
	display: flex;
	flex-direction: row;
	align-items: center;
	width: 100%;
	flex-wrap: wrap
}

.filter-input-container button {
	background-color: #33f18a;
	color: #fff;
	border: none;
	border-radius: 999px;
	padding: 5px 15px;
	transition-duration: .5s;
	margin-left: auto
}

.filter-input-container button:hover {
	filter: brightness(.9);
	cursor: pointer;
	transition-duration: .5s
}

.inner-filter-container {
	margin: 5px
}

.inner-filter-container select {
	background-color: #fff;
	padding: 5px 15px;
	border-radius: 25px;
	cursor: pointer;
	border: 1px solid #e2e2e2;
	box-shadow: rgba(0, 0, 0, .05) 0 5px 15px;
	outline: 0
}

.inner-filter-container select:hover {
	filter: brightness(.9);
	cursor: pointer;
	transition-duration: .5s
}

option {
	background-color: #fff;
	padding: 5px 15px;
	font-size: 1.1em
}

.inner-filter-container input {
	border: 1px solid #e2e2e2;
	padding: 5px;
	border-radius: 25px;
	box-shadow: rgba(0, 0, 0, .05) 0 5px 15px;
	outline: 0
}

input[type=checkbox] {
	-webkit-appearance: none;
	appearance: none;
	background-color: #fff;
	margin: 0;
	margin-left: 10px;
	cursor: pointer;
	font: inherit;
	color: #33f18a;
	width: 1.05em;
	height: 1.05em;
	border: .15em solid #33f18a;
	border-radius: .15em;
	display: grid;
	place-content: center;
	transition-duration: .5s
}

input[type=checkbox]:hover {
	background-color: #f3f3f3;
	transition-duration: .5s
}

input[type=checkbox]::before {
	content: "";
	width: .65em;
	height: .65em;
	clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0, 43% 62%);
	transform: scale(0);
	transform-origin: bottom left;
	transition: 120ms transform ease-in-out;
	box-shadow: inset 1em 1em var(--form-control-color);
	background-color: CanvasText
}

input[type=checkbox]:checked::before {
	transform: scale(1)
}

.checkbox-container {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	font-size: 13px
}

@media only screen and (max-width:380px) {
	.filter-input-container button {
		font-size: 10px
	}

	.inner-filter-container select {
		padding: 5px 5px
	}
}
</style>